<template>
    <section class="qrcode-view">
        <HeaderComponent :title="'QrCode'" />

        <div class="qrcode">
            <div class="container">
                <VueQRCodeComponent :text="parseInt(getCurrDependent.CDCONSUMIDOR).toString()" />
            </div>
        </div>

        <footer>
            <div class="exportButton" @click="exportQrcode" v-if="!exporting">
                <i class="fa fas fa-file-export"></i>
                <h1>Exportar por email</h1>
            </div>
            <h1 id="exporting" v-else-if="exporting">
                Exportando
                <!-- animated icon indicating loading -->
                <i class="fa fa-spinner fa-spin fa-fw"></i>
            </h1>
        </footer>
    </section>
</template>

<script>
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import VueQRCodeComponent from 'vue-qrcode-component'
import { sendEmail } from '@/components/controllers/EmailController.js'
import { showSuccessNotification, showErrorNotification } from '@/libs/Util'
import { mapGetters } from 'vuex'
import QRCode from 'qrcode'

export default {
    name: 'QrCodeView',
    components: {
        HeaderComponent,
        VueQRCodeComponent
    },
    data () {
        return {
            exporting: false
        }
    },
    methods: {
        exportQrcode: async function () {
            const img = await QRCode.toDataURL(parseInt(this.getCurrDependent.CDCONSUMIDOR).toString())

            this.exporting = true
            const data = {
                name: this.getCurrDependent.NMCONSUMIDOR,
                img: img
            }
            await sendEmail('QRCode do Cartão', null, false, 'getQrCodeEmail', data).then((res) => {
                this.exporting = false
                if (!res.error) {
                    showSuccessNotification({
                        title: '',
                        text: 'Email enviado com sucesso para ' + this.getCurrDependent.DSEMAILCONS + '.'
                    })
                } else {
                    showErrorNotification({
                        title: '',
                        text: 'Erro ao enviar email!'
                    })
                }
            })
        }
    },
    computed: {
        ...mapGetters(['getCurrDependent'])
    }
}
</script>

<style lang="less" scoped>
@keyframes dots {
    0%, 20% {
        content: ".";
    }
    40% {
        content: "..";
    }
    60% {
        content: "...";
    }
    80%, 100% {
        content: "";
    }
}
// center qrcode
.qrcode {
    display: flex;
    justify-content: center;
    margin: 0px 20px;
}

.container {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 4px solid var(--cardBorder);
    background-color: #FFFFFF;
    padding: 20px;
    box-sizing: border-box;
    /* Adiciona o box-sizing adequado */
}

// botao de exportar no final da pagina, centralizado, com icone e texto na mesma linha
footer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100vw;
    position: fixed;
    bottom: 0px;
    left: 0px;

    .exportButton {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 40px 0px 20px 0px;
        padding: 20px;
        border: 1px solid var(--cardBorder);
        box-shadow: 2px 2px 4px var(--cardBorder);
        border-radius: 5px;

        i {
            color: var(--iconColor);
            margin-right: 10px;
        }

        h1 {
            font-weight: 600;
        }
    }

    #exporting {
        margin: 20px 0px 40px 0px;
        font-size: 16px;
        font-weight: 600;
        color: var(--iconColor);
    }

}

// small screen remove border
@media (max-width: 350px) {
    .container {
        border: none;
    }

}
</style>
